import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Clock3, PauseCircle, WifiOff } from "lucide-react";
import type { MonitorStatus } from "../shared/types";

export function StatusBadge({ status }: { status: MonitorStatus }) {
  const labels = { UP: "运行正常", DOWN: "发生异常", PENDING: "等待检测", PAUSED: "已暂停" };
  const Icon =
    status === "UP"
      ? CheckCircle2
      : status === "DOWN"
        ? WifiOff
        : status === "PAUSED"
          ? PauseCircle
          : Clock3;
  return (
    <span className={`status status-${status.toLowerCase()}`}>
      <Icon size={13} />
      {labels[status]}
    </span>
  );
}

export function PageHead({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <header className="page-head">
      <div>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {action}
    </header>
  );
}

export function Skeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="skeleton-stack" aria-label="正在加载">
      {Array.from({ length: rows }, (_, index) => (
        <div className="skeleton" key={index} />
      ))}
    </div>
  );
}

export function EmptyState({
  title,
  text,
  action,
}: {
  title: string;
  text: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="empty-icon">
        <AlertTriangle size={22} />
      </div>
      <h3>{title}</h3>
      <p>{text}</p>
      {action}
    </div>
  );
}

export function ErrorState({ error, retry }: { error: string; retry?: () => void }) {
  return (
    <div className="error-state">
      <WifiOff />
      <div>
        <strong>数据暂时无法加载</strong>
        <p>{error}</p>
      </div>
      {retry && (
        <button className="button subtle" onClick={retry}>
          重新加载
        </button>
      )}
    </div>
  );
}
